import { useState, useEffect } from 'react';
import { expertService } from '../services/apiService';
import ExpertList from '../components/ExpertList';

const Experts = () => {
  const [experts, setExperts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchExperts = async () => {
    try {
      setLoading(true);
      const data = await expertService.getAllExperts();
      setExperts(data);
    } catch (err) {
      setError(err.message || 'Failed to fetch experts');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExperts();
  }, []);

  if (loading) {
    return <div className="text-center py-8">Loading experts...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">{error}</div>;
  }

  return (
    <div>
      <h2 className="text-2xl font-medium text-gray-800 mb-6">Global Experts Management</h2>
      <ExpertList experts={experts} fetchExperts={fetchExperts} />
    </div>
  );
};

export default Experts;
